import classNames from 'classnames';
import { SkeletonLine } from '@/shared/components/atoms/LoadingSkeleton';
import { Tooltip } from '@/shared/components/molecules/Tooltip';
import SparklesIconSmall from '@/shared/icons/flip-ui-kit/small/Sparkles';
import { apyToText } from '@/shared/utils/boost';

export const IncentivisedApyText = ({
  totalApy,
  baseApy,
  rewardsApy,
  tooltipContent,
  className = 'text-20',
  showBreakdown = false,
  showNegativeRewards = false,
  isLoading,
  underlineColorClassname = 'group-hover/incentives:border-cf-white',
}: {
  totalApy: number;
  baseApy: number;
  rewardsApy: number;
  tooltipContent?: React.ReactNode;
  className?: string;
  showBreakdown?: boolean;
  showNegativeRewards?: boolean;
  isLoading?: boolean;
  underlineColorClassname?: string;
}) =>
  // eslint-disable-next-line no-nested-ternary
  isLoading ? (
    <SkeletonLine width={75} height={50} />
  ) : rewardsApy > 0 ? (
    <div className="flex">
      <Tooltip content={tooltipContent} tooltipClassName="!bg-cf-gray-3-5 !border-cf-gray-4">
        <div
          className={classNames(
            'group/incentives flex w-[100px] flex-col gap-y-[2px] font-aeonikMedium text-cf-white',
            className,
          )}
        >
          <div className="flex w-fit items-center gap-1">
            {!showBreakdown && <SparklesIconSmall className="text-cf-green-1" />}{' '}
            <div
              className={classNames(
                'border-b-2 border-b-transparent group-hover/incentives:border-dotted',
                underlineColorClassname,
              )}
            >
              {apyToText(showBreakdown ? baseApy : totalApy)}
            </div>
          </div>
          {showBreakdown && (
            <div className="flex items-center text-14 text-cf-green-1">
              <SparklesIconSmall />
              {showNegativeRewards ? '-' : '+'}
              {apyToText(rewardsApy)}
            </div>
          )}
        </div>
      </Tooltip>
    </div>
  ) : (
    <div className="flex">
      <div className={classNames('w-[100px] font-aeonikMedium text-cf-white', className)}>
        {apyToText(baseApy)}
      </div>
    </div>
  );
